import { Link, useLocation } from "react-router-dom";
import styled, { useTheme } from "styled-components";

import HomeLinkIcon from "../../assets/icons/HomeLinkIcon";
import ProfileLinkIcon from "../../assets/icons/ProfileLinkIcon";
import CircledPlusIcon from "../../assets/icons/CircledPlusIcon";

export enum Pathnames {
  AUTH = "/auth",
  HOME = "/",
  PROFILE = "/profile",
  ADD_LINK = "/add-link",
  SETTINGS = "/settings",
}

const BottomNavigation = () => {
  const theme = useTheme();

  const location = useLocation();

  return (
    <StyledBottomNav>
      <StyledNavContent>
        <Link to={Pathnames.HOME}>
          <HomeLinkIcon
            color={
              location.pathname === Pathnames.HOME
                ? theme.colors.primary
                : undefined
            }
          />
        </Link>

        <Link to={Pathnames.ADD_LINK}>
          <CircledPlusIcon
            color={
              location.pathname === Pathnames.ADD_LINK
                ? theme.colors.primary
                : undefined
            }
          />
        </Link>

        <Link to={Pathnames.PROFILE}>
          <ProfileLinkIcon
            color={
              location.pathname === Pathnames.PROFILE
                ? theme.colors.primary
                : undefined
            }
          />
        </Link>
      </StyledNavContent>
    </StyledBottomNav>
  );
};

const StyledBottomNav = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 12px 10px 20px;
  border-top: 1px solid ${({ theme }) => theme.colors.text};
  background-color: ${({ theme }) => theme.colors.dark};
`;

const StyledNavContent = styled.div`
  max-width: 500px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: auto;
`;

export default BottomNavigation;
